import { getToken } from 'src/utils/helper';
import axios from '../../../utils/axios';
import { createSlice } from '@reduxjs/toolkit';

// API of userList
const SUBSCRIBER_LIST = `${process.env.REACT_APP_BASE_URL}/subscribers`;

const initialState = {
  data: [],
  subscriberDetailsData: {},
  subscriberUsersDetails: [],
  subscriberPostsList:[],
  status: null,
  message: null,
};

export const CustomerSlice = createSlice({
  name: 'UserList',
  initialState,
  reducers: {
    subscriberListSuccess: (state, action) => {
      state.data = action.payload.data;
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    subscriberListFailure: (state, action) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    subscribeDetailsSuccess: (state, action) => {
      state.subscriberDetailsData = action.payload.subscriberDetailsData;
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    subscribeUserDetailsSuccess: (state, action) => {
      state.subscriberUsersDetails = action.payload.subscriberUsersDetails;
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    subscribePostListSuccess: (state, action) => {
      state.subscriberPostsList = action.payload.subscriberPostsList;
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
    subscriberDetailsFailure: (state, action) => {
      state.status = action.payload.status;
      state.message = action.payload.message;
    },
  },
});

export const {
  subscriberListSuccess,
  subscriberListFailure,
  subscribeDetailsSuccess,
  subscribeUserDetailsSuccess,
  subscribePostListSuccess,
  subscriberDetailsFailure,
} = CustomerSlice.actions;

// export const fetchSubscriberList = () => async (dispatch) => {
//   let api_url = `${SUBSCRIBER_LIST}`;
//   const token = getToken();

//   try {
//     const response = await axios.get(api_url, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     await dispatch(
//       subscriberListSuccess({
//         status: response.data.status,
//         message: response.data.message,
//         data: response.data.data,
//       }),
//     );

//     return response?.data;
//   } catch (error) {
//     dispatch(
//       subscriberListFailure({
//         status: false,
//         message: error.message,
//       }),
//     );
//   }
// };


export const fetchSubscriberList = (queryString) => async (dispatch) => {
  let api_url = `${SUBSCRIBER_LIST}`;
  
  // Append query string if provided
  if (queryString) {
    api_url = `${api_url}?${queryString}`;
  }
  
  const token = getToken();
  
  try {
    const response = await axios.get(api_url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    
    await dispatch(
      subscriberListSuccess({
        status: response.data.status,
        message: response.data.message,
        data: response.data.data,
      })
    );
    
    return response?.data;
  } catch (error) {
    dispatch(
      subscriberListFailure({
        status: false,
        message: error?.response?.data?.message || error.message,
      })
    );
    throw error; // This allows the component to handle the error if needed
  }
};
export const getSubscriberDetails = (id) => async (dispatch) => {
  try {
    let api_url = `${SUBSCRIBER_LIST}`;
    const token = getToken();
    const response = await axios.get(`${api_url}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    await dispatch(
      subscribeDetailsSuccess({
        status: response.data.status,
        message: response.data.message,
        subscriberDetailsData: response.data.data,
      }),
    );
    return response?.data;
  } catch (error) {
    dispatch(
      subscriberDetailsFailure({
        status: false,
        message: error.message,
      }),
    );
  }
};

export const getSubscriberUserDetails = (id, reqBody) => async (dispatch) => {
  try {
    let api_url = `${SUBSCRIBER_LIST}`;
    const token = getToken();
    const response = await axios.post(`${api_url}/${id}`, reqBody, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    await dispatch(
      subscribeUserDetailsSuccess({
        status: response.data.status,
        message: response.data.message,
        subscriberUsersDetails: response.data.data,
      }),
    );
    return response?.data;
  } catch (error) {
    dispatch(
      subscriberDetailsFailure({
        status: false,
        message: error.message,
      }),
    );
  }
};



export const getSubscriberPostList = (id, reqBody) => async (dispatch) => {
  try {
    let api_url = `${SUBSCRIBER_LIST}`;
    const token = getToken();
    const response = await axios.post(`${api_url}/${id}`, reqBody, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    await dispatch(
      subscribePostListSuccess({
        status: response.data.status,
        message: response.data.message,
        subscriberPostsList: response.data.data,
      }),
    );
    return response?.data;
  } catch (error) {
    dispatch(
      subscriberDetailsFailure({
        status: false,
        message: error.message,
      }),
    );
  }
};

export default CustomerSlice.reducer;
